module.exports = __webpack_public_path__ + "img/qyh01.efbd9574.jpg";